import React from "react";

import { Button, Header } from "semantic-ui-react";

import { useBooleanState, useSelection } from "hooks";

import { useAccessListStatus, useAccessListTable } from "./hooks";
import AddGatedCustomersModal from "./components/AddGatedCustomersModal";
import { AccessListTable } from "./components";

const ACCESS_STATUS = {
  APPROVE: "Approved",
  DENY: "Denied",
};

export function TemplatesSettings() {
  const [
    isAddGatedCustomersModalOpen,
    openAddGatedCustomersModal,
    closeAddGatedCustomersModal,
  ] = useBooleanState();

  const { reloadData, loading, accessList, ...accessListTable } =
    useAccessListTable();

  const { selected, onSelectAll, ...restSelection } = useSelection(accessList);

  const onChangeStatus = () => {
    reloadData();
    onSelectAll(false);
  };

  const { updateAccessStatus, loading: loadingUpdateStatus } =
    useAccessListStatus(onChangeStatus);

  return (
    <React.Fragment>
      <Header as="h1">Gated Workflow Customer Access List</Header>
      <div>
        <AccessListTable
          {...accessListTable}
          {...restSelection}
          accessList={accessList}
          loading={loading}
          selected={selected}
          onSelectAll={onSelectAll}
        />

        <div
          style={{
            display: "flex",
            gap: "14px",
            marginTop: loading ? "14px" : "0",
          }}
        >
          <Button
            primary
            content="Add Customers"
            onClick={openAddGatedCustomersModal}
            disabled={selected?.length > 0}
          />
          {selected?.length > 0 && (
            <React.Fragment>
              {Object.keys(ACCESS_STATUS).map((statusKey) => {
                return (
                  <Button
                    key={`button-${statusKey}`}
                    primary
                    content={`${
                      statusKey.charAt(0) + statusKey.slice(1).toLowerCase()
                    } Access`}
                    onClick={() => {
                      return updateAccessStatus(
                        selected,
                        ACCESS_STATUS[statusKey]
                      );
                    }}
                    disabled={loadingUpdateStatus}
                  />
                );
              })}
            </React.Fragment>
          )}
        </div>
      </div>

      {isAddGatedCustomersModalOpen && (
        <AddGatedCustomersModal
          onClose={closeAddGatedCustomersModal}
          onSubmit={() => {
            reloadData();
            closeAddGatedCustomersModal();
          }}
        />
      )}
    </React.Fragment>
  );
}

export default TemplatesSettings;
